import { render, staticRenderFns } from "./main-documents.vue?vue&type=template&id=384e65d3&scoped=true&"
import script from "./main-documents.vue?vue&type=script&lang=js&"
export * from "./main-documents.vue?vue&type=script&lang=js&"
import style0 from "./main-documents.vue?vue&type=style&index=0&id=384e65d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384e65d3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('384e65d3')) {
      api.createRecord('384e65d3', component.options)
    } else {
      api.reload('384e65d3', component.options)
    }
    module.hot.accept("./main-documents.vue?vue&type=template&id=384e65d3&scoped=true&", function () {
      api.rerender('384e65d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/personal-employee/documents/main-documents.vue"
export default component.exports